if (document.querySelector("#map") != null) {

    function initMap() {
        ymaps.ready(init);
        function init() {
            window.myMap = new ymaps.Map("map", {
                center: window.mapCenter,
                zoom: 9
            }, {
                searchControlProvider: 'yandex#search'
            });

            window.clusterer = new ymaps.Clusterer({preset: 'islands#icon', clusterIconColor: '#00185D'});

            myYaMapPlacemarksSection.forEach(function (el) {
                clusterer.add(
                    new ymaps.Placemark(
                        el.coords,
                        {
                            balloonContentHeader: '',

                            balloonContentBody: '' +
                                '<div class="in_map"> ' +
                                '<a href = "' + el.url + '"><img src="' + el.picsrc + '" height="150"></a><br/>' +
                                '<a href = "' + el.url + '">' + el.name + '</a><br>' +
                                // '<p class="rating_line">' + el.rating_html + '</p><br>' +
                                '<p class="price"> Цена: ' + el.price + ' руб./сутки</p>' +
                                // '<a href = "' + el.url + '">Подробнее</a><br>' +
                                // '<span class="fiol_button js-show-modal" data-modal="takerent" data-id="' + el.id + '">Забронировать</span>' +
                                '</div>',


                            hintContent: el.name
                        },
                        {
                            preset: 'islands#icon',
                            iconColor: '#00185D'
                        }
                    )
                )
            });


            clusterer.options.set({
                gridSize: 86
            });

            window.myMap.geoObjects.add(clusterer);
        };
    }

    addScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;apikey=fba57e2a-7d0a-4059-a052-cae61f80b03f', initMap)
}